import React from "react";
import { Avatar, Badge, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import Thp from "./../../assets/images/trophies/JuegoMujeres_trophy_yellow.png";
import "./styles.scss";

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 0,
  height: 50,
  border: `${theme.palette.background.paper}`,
}));

export type Props = {
  url: string;
  title?: string;
  clasName?: string;
  width?: number;
  height?: number;
  badgeContent?: number;
  showThrophy?: boolean;
  onClick: () => void;
};
const CircularAvatar = (props: Props) => {
  console.log("Points", props.badgeContent);
  return (
    <IconButton onClick={props.onClick} className="gameHeaderIconAvatar">
      <Avatar
        className={props.clasName}
        variant="circular"
        src={props.url}
        sx={{ width: props.width || 100, height: props.height || 100 }}
        alt={props.title}
      >
        {props.title}
      </Avatar>
      {props.showThrophy === true && (
        <Badge
          overlap="circular"
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          badgeContent={
            <SmallAvatar style={{ width: 45, height: 45 }} src={Thp} />
          }
        />
      )}
    </IconButton>
  );
};

export default CircularAvatar;
